import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { selectContent } from "../services/basket";
import { parameterize } from "../utils/string";
import { isPremium } from "../services/auth";

import Buttons from "./buttons";
// UniqueLinks is imported in PropTypes but not used in the component
// Commenting out to fix the unused variable warning
// import UniqueLinks from "./unique-links";
import ResponsiveImage from "./responsive-image";

const Card = (props) => {
  // We no longer need to fetch the imageHost from site metadata
  // since we're using the ResponsiveImage component which handles this internally

  const {
    description,
    hero,
    premium_4k,
    premium_lg,
    premium_sm,
    title,
    vid,
    skipLazyLoading = false
  } = props

  // We're no longer using the gallery images
  // const images = heroes || [1,2,3,4]
  const link = `/videos${props.slug.replace(/\/$/, '')}`
  const slug = props.slug.replace(/\//g, '')

  return (
    <article key={`card-${vid}`} className="flex flex-wrap card overflow-hidden bg-transparent relative">
      <section className="w-full">
        <Link
          to={link}
          rel="bookmark"
          name={slug}
          onClick={() => selectContent({ contentType: `card-image`, itemId: parameterize(title) })}
          onKeyDown={() => selectContent({ contentType: `card-image`, itemId: parameterize(title) })}
          className="titleLink block"
        >
          <div className="w-full relative" style={{ aspectRatio: '16/9' }}>
            <ResponsiveImage 
              src={hero}
              alt={title}
              className="w-full h-full object-cover absolute inset-0"
              layout="hero"
              skipLazyLoading={skipLazyLoading}
              imgAttributes={{
                key: `${vid}-hero-${hero}`,
                'data-component': 'card-image',
                'data-testid': 'cloudflare-image',
                'data-vid': vid,
                'data-title': parameterize(title)
              }}
            />
          </div>
        </Link>
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-transparent to-black/50 pointer-events-none"></div>
        {isPremium() && (
          <>
            {/* Desktop overlay buttons */}
            <div className="absolute bottom-0 left-0 right-0 z-10 p-2 bg-gradient-to-t from-black/80 to-transparent pointer-events-auto hidden md:block">
              <Buttons vid={vid} premium_4k={premium_4k} premium_lg={premium_lg} premium_sm={premium_sm} />
            </div>
            {/* Mobile buttons below image */}
            <div className="relative w-full z-10 mt-1 pt-1 px-2 pb-2 bg-black/10 rounded md:hidden">
              <Buttons vid={vid} premium_4k={premium_4k} premium_lg={premium_lg} premium_sm={premium_sm} />
            </div>
          </>
        )}
        <h2 className="absolute top-2 left-2 right-2 font-bold text-lg md:text-2xl text-white">
          <Link
            to={link}
            rel="bookmark"
            name={slug}
            onClick={() => selectContent({ contentType: `card-title`, itemId: parameterize(title) })}
            onKeyDown={() => selectContent({ contentType: `card-title`, itemId: parameterize(title) })}
            className="titleLink pointer-events-auto"
          >
            { title }
          </Link>
        </h2>
      </section>
      <section className="w-full">
        <div
          className="sr-only"
          dangerouslySetInnerHTML={{ __html: description }} />
        {/* Eye icon removed */}
        {/* Tags, girls links, and buttons removed */}
      </section>
      {/* Gallery section removed to only show hero image */}
    </article>
  )
}

Card.propTypes = {
  cardType: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  girls: PropTypes.array, // Kept for UniqueLinks component
  hero: PropTypes.string.isRequired,
  imageHost: PropTypes.string,
  location: PropTypes.object.isRequired,
  previewId: PropTypes.string,
  slug: PropTypes.string.isRequired,
  tags: PropTypes.array, // Kept for UniqueLinks component
  premium_4k: PropTypes.string,
  premium_lg: PropTypes.string,
  premium_sm: PropTypes.string,
  related: PropTypes.bool,
  streamId: PropTypes.string,
  title: PropTypes.string.isRequired,
  vid: PropTypes.string.isRequired,
  skipLazyLoading: PropTypes.bool
}

export default Card
